<template>
  <div class="version-page">
    <div class="content-scroll">
      <div class="content-card">
        <div class="section">
          <h3>版本号</h3>
          <p>幻之大地<span class="highlight">V0.1.3测试版</span></p>
        </div>

        <div class="section">
          <h3>本版说明</h3>
          <p>此测试版本的推出意在让所有喜爱娱乐的朋友们对我们的系统进行测试，并提出宝贵的修改意见。同时我们也希望从大家的意见中获取一些新的创意，把这个虚拟的世界建设的更加丰富和精彩。</p>
          <p>您的所有意见（如系统BUG、操作的方便程度、对用户行为和内容的建议等）都将得到第一时间的反馈，同时我们将针对这些意见在马上推出的β测试版中进行改进，并增加新的元素。所有www.huanzhidadi.com的工作人员感谢您的关心和支持！</p>
          <p>同时，<span class="highlight">如果您对这个虚拟世界非常有兴趣并且愿意投入其中，我们也非常欢迎您的加盟！</span></p>
        </div>

        <div class="section">
          <h3>版本内容</h3>
          <p>本版的系统实际上已经非常完整，整个用户体制可以正常运行，但不排除出现各种BUG的情况，希望大家能够理解。</p>
          <p>在本版中，由于时间和人手的关系，有很多内容还没有加入进来，这些内容将在后续测试版中加入，到时候，整个世界的元素会更加丰富。</p>
          <p>另外，一些工作等页面的美工工作还没有完成，如果影响了您的视觉观感，也希望您能够予以谅解。</p>
        </div>

        <div class="section">
          <h3>意见反馈</h3>
          <p>可以直接在王都中央广场的电子公告牌上发表文章，也可以按照如下地址联系我们：</p>
          <p>E-mail地址：<a href="mailto:2whol@163.com">2whol@163.com</a></p>
        </div>
      </div>
    </div>

    <div class="bottom-fixed">
      <div class="back-link">
        <router-link :to="{name:'login'}">← 返回登录</router-link>
      </div>
      <div class="page-footer">
        <div class="copyright">
          ©Copyright 2019 <a href="http://www.huanzhidadi.com" target="_blank">幻之大地</a> ALL RIGHTS RESERVED. <a href="https://beian.miit.gov.cn" target="_blank" title="豫ICP备17045248号-3">豫ICP备17045248号-3</a>
        </div>
        <div class="advice">
          抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。<br/>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    methods: {
    },
    mounted: function () {
      var _this = this;
    },
    data(){
      return {
      }
    }
  }
  
</script>
<style scoped>
.version-page {
  flex: 1;
  min-height: 0;
  max-width: 720px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 0;
}

/* ========== 正文滚动区 ========== */
.content-scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 12px 12px 0;
}

.content-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 28px 30px;
  box-sizing: border-box;
}

.section {
  margin-bottom: 20px;
}

.section:last-child {
  margin-bottom: 0;
}

.section h3 {
  margin: 0 0 10px;
  font-size: 16px;
  color: #303133;
  padding-left: 8px;
  border-left: 3px solid #409eff;
}

.section p {
  margin: 0 0 10px;
  font-size: 15px;
  line-height: 1.9;
  color: #4a4a4a;
  text-indent: 2em;
}

.section p:last-child {
  margin-bottom: 0;
}

.content-card .highlight {
  color: #e6422e;
  font-weight: 600;
}

.content-card a {
  color: #409eff;
  text-decoration: none;
}

.content-card a:hover {
  text-decoration: underline;
}

/* ========== 底部固定区 ========== */
.bottom-fixed {
  flex-shrink: 0;
  padding: 0 16px;
}

.back-link {
  text-align: center;
  padding: 10px 0;
}

.back-link a {
  font-size: 14px;
  color: #909399;
  text-decoration: none;
  transition: color 0.2s;
}

.back-link a:hover {
  color: #409eff;
}

.page-footer {
  text-align: center;
  padding-bottom: 16px;
}

.page-footer .copyright {
  font-size: 12px;
  color: #999;
  line-height: 1.6;
}

.page-footer .copyright a {
  color: #909399;
  text-decoration: none;
}

.page-footer .copyright a:hover {
  color: #409eff;
}

.page-footer .advice {
  font-size: 11px;
  color: #aaa;
  line-height: 1.7;
  margin-top: 4px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .content-scroll {
    padding: 8px 8px 0;
  }

  .content-card {
    padding: 20px 16px;
    border-radius: 10px;
  }

  .section {
    margin-bottom: 16px;
  }

  .section h3 {
    font-size: 15px;
  }

  .section p {
    font-size: 14px;
    line-height: 1.75;
    margin-bottom: 8px;
  }

  .back-link a {
    font-size: 13px;
  }

  .bottom-fixed {
    padding: 0 10px;
  }

  .page-footer .copyright {
    font-size: 10px;
  }

  .page-footer .advice {
    font-size: 10px;
  }
}
</style>
